module.exports = __webpack_public_path__ + "static/media/w (16).6024429b.jpg";